<template>
  <div class="map-search">
    <input 
      autocomplete="off" 
      :value="value" 
      @input="$emit('input', $event.target.value)" 
      type="text" 
      placeholder="请输入船舶MMSI或船名">
    <i 
      class="el-icon-close" 
      title="清空" 
      @click="$emit('input', '')" 
      v-show="value"></i>
    <i 
      class="el-icon-loading" 
      title="加载中" 
      v-show="isSearching"></i>
    <div class="map-search-bar">
      <i 
        class="el-icon-search" 
        title="查询船舶" 
        @click="$emit('search')"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipSearch',
  props: {
    value: {
      type: String,
      default: ''
    },
    isSearching: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.map-search {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1000;
  display: flex;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  width: 250px;
  height: 36px;
  align-items: center;
}

.map-search input {
  flex: 1;
  border: none;
  padding: 8px 10px;
  font-size: 14px;
  height: 100%;
  outline: none;
}

.map-search i {
  padding: 0 8px;
  cursor: pointer;
  color: #909399;
  font-size: 16px;
}

.map-search i:hover {
  color: #409EFF;
}

.map-search-bar {
  background-color: #409EFF;
  height: 100%;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-search-bar i {
  color: #fff;
  font-size: 18px;
}
</style> 